import { render, staticRenderFns } from "./hazopAction.vue?vue&type=template&id=820f4afe"
import script from "./hazopAction.vue?vue&type=script&lang=js"
export * from "./hazopAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('820f4afe')) {
      api.createRecord('820f4afe', component.options)
    } else {
      api.reload('820f4afe', component.options)
    }
    module.hot.accept("./hazopAction.vue?vue&type=template&id=820f4afe", function () {
      api.rerender('820f4afe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/hazop/action/hazopAction.vue"
export default component.exports